import { createSlice } from '@reduxjs/toolkit';

import { appStorage } from '@sternum/web/services/appStorage';

export interface AuditLogState {
  isAuditLogFiltersSidebarOpen: boolean;
}

const initialState: AuditLogState = {
  isAuditLogFiltersSidebarOpen: appStorage.getIsAuditLogFiltersSidebarOpen() ?? true,
};

export const auditLogSlice = createSlice({
  name: 'auditLog',
  initialState,
  reducers: {
    toggleIsAuditLogFiltersSidebarOpenAction(state) {
      state.isAuditLogFiltersSidebarOpen = !state.isAuditLogFiltersSidebarOpen;
    },
  },
});

export const { toggleIsAuditLogFiltersSidebarOpenAction } = auditLogSlice.actions;
